module.exports = __webpack_public_path__ + "static/media/Articles 6.7b3e1fbd.svg";